import dayjs from "dayjs";
import moment from "moment";
import { toast } from "react-toastify";
import { paymentLinkDates } from "../constants/options/linkExpireDates";
export function handleError(error, setErrors) {
  if (error.response.status === 401 || error.response.status === 419) {
    // doğrulama yapılamadı
    toast.error("Lütfen kayıtlı hesabınıza giriş yapın!");
  } else if (error.response.status === 500) {
    toast.error(
      "Bir sorun oluştu ve şu anda işleminizi gerçekleştiremiyoruz. Lütfen birkaç dakika sonra tekrar deneyin. Sorun devam ederse destek ekibimizle iletişime geçebilirsiniz."
    );
  } else if (error.response.status > 401 && error.response.status < 419) {
    toast.error(error.response.data.message);
  } else if (error.response.status === 422 || error.response.status === 400) {
    if (setErrors) {
      setErrors(error.response.data.message);
    }

    const message = error.response.data.message;
    if (typeof message === "object") {
      toast.error(
        "Lütfen gönderdiğiniz bilgileri kontrol ediniz. Eksik yada hatalı bilgi gönderdiniz."
      );
    } else {
      toast.error(error.response.data.message);
    }
  }
  // Do something with response error
  console.error(error.response);
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function formatDate(date) {

  var dates = paymentLinkDates;
  var d = new Date().addDays(1);
 

  
   var month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("/");
}

export function formatDateOnFront(date) {
 
  const format = "	MM.DD.YYYY hh:mm:ss"; 
  // var formatted =   dayjs(date).format(format);
  var formatted =moment(date).format("DD.MM.YYYY HH:mm");
  
  return formatted;
}
export function formatDateOnFrontWithoutTime(date) {
 
  const format = "	MM.DD.YYYY hh:mm:ss"; 
  // var formatted =   dayjs(date).format(format);
  var formatted =moment(date).format("DD.MM.YYYY");
  
  return formatted;
}

export function formatCurrency(amount, isFourDigits) {
 
  const formatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: isFourDigits ? 4 : 2, 
    maximumFractionDigits: isFourDigits ? 4 : 2,
  });

 var result =  formatter.format((amount)).replace('₺', '')
 
 if (result != 'NaN') {
  return result;
 }
  return amount;
}


Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}